export const technologyIcon = [
    {
      technologyName: "aptitude",
      technologyIconImageUrl: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original-wordmark.svg"
   },
    {
      technologyName: "core-subject",
      technologyIconImageUrl: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original-wordmark.svg"
   },
   {
      technologyName: "react",
      technologyIconImageUrl: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original-wordmark.svg"
   },
   {
      technologyName: "Javascript",
      technologyIconImageUrl: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg"
   },
   {
      technologyName: "java",
      technologyIconImageUrl: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/java/java-original-wordmark.svg"
   },
   {
      technologyName: "C++",
      technologyIconImageUrl: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/cplusplus/cplusplus-original.svg"
   },
   {
      technologyName: "python",
      technologyIconImageUrl: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original-wordmark.svg"
   },
   {
      technologyName: "nodejs",
      technologyIconImageUrl: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nodejs/nodejs-original-wordmark.svg"
   },
   {
      technologyName: "Expressjs",
      technologyIconImageUrl: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/express/express-original-wordmark.svg"
   },
   {
      technologyName: "Ruby",
      technologyIconImageUrl: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/ruby/ruby-original-wordmark.svg"
   },
   {
      technologyName: "Mongodb",
      technologyIconImageUrl: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mongodb/mongodb-original-wordmark.svg"
   },
   {
      technologyName: "Nextjs",
      technologyIconImageUrl: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nextjs/nextjs-original-wordmark.svg"
   },
   {
      technologyName: "html",
      technologyIconImageUrl: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/html5/html5-original-wordmark.svg"
   },
   {
      technologyName: "CSS",
      technologyIconImageUrl: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/css3/css3-original-wordmark.svg"
   },
   {
      technologyName: "Sass",
      technologyIconImageUrl: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/sass/sass-original.svg"
   }
];